import CustomTextField from "components/CustomTextField";
import { useAddCrmLeadMutation } from "features/banking/BankingApiSlice";
import {
  useGetLoanProductMasterQuery,
  useUploadLeadsMutation,
} from "features/CrmDashboardComp/CmrApiSlice";

import { useEffect, useState } from "react";
import { Col, Spinner, Button } from "react-bootstrap";

import Select from "react-select";
import { Input, Label, Row, FormGroup } from "reactstrap";

import {
  useGetStatesQuery,
  useGetDistrictByStateQuery,
  useGetBlockByDistrictQuery,
} from "services/locationApiSlice";
import swal from "sweetalert";
import { toast } from "react-toastify";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const CrmAddLead = ({
  setOpenLeadModal,
  refetch,
  selectedProduct,
  isaddInsurer,
}) => {
  const [stateId, setStateId] = useState("");
  const [districtId, setDistrictId] = useState("");
  const [blockId, setBlockId] = useState("");
  const { data: getStates } = useGetStatesQuery();
  const { data: dataDistrict } = useGetDistrictByStateQuery(stateId);
  const { data: dataBlock } = useGetBlockByDistrictQuery(districtId);
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [stateName, setStateName] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [blockName, setBlockName] = useState("");
  const [loadingStateOptions, setloadingStateOptions] = useState(true);
  const [loadingDistrictOptions, setloadingDistrictOptions] = useState(true);
  const { data: loanMasterData } = useGetLoanProductMasterQuery();

  const [disableButton2, disableSubmitBtn] = useState(false);

  const [loanData, setLoanData] = useState([]);

  const [createCrmLead] = useAddCrmLeadMutation();
  const [uploadLeads] = useUploadLeadsMutation();

  const [residentialPinState, setresidentialPinState] = useState("StateLevel");
  const [PincodeValue, setPincode] = useState("");
  const [PincodeDataList, setPincodeDataList] = useState([]);
  const [pincodeError, setPinCodeError] = useState(false);
  const [leadDataAdd, setLeadData] = useState({
    first_name: "",
    last_name: "",
    lead_source: "",
    primary_occupation: "",
    phone_number: "",
    DOB: "",
    gender: "",
    product_name: "",
    product_value: "",
    // pincode: "",
    service_name: "Insurance",
    type: "",
    num_cattle: "",
  });
  const [showSingleLeads, setShowSingleLeads] = useState(true);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [selectedFile, setSelectedFile] = useState();
  const [cattleData, setCattleData] = useState([
    {
      cattle_id: generateCattleId(),
      cattle_tag_number: "",
      cattle_tag_date: "",
      name: leadDataAdd?.first_name,
    },
  ]);
  const customStyles = {
    control: (base) => ({
      ...base,
      height: 50,
      minHeight: 50,
    }),
  };
  function generateCattleId() {
    return "CATIB" + Math.floor(100000 + Math.random() * 900000); // e.g., CILIB965177
  }
  useEffect(() => {
    if (getStates !== undefined) {
      setStateList(getStates?.data?.results);
      setloadingStateOptions(false);
    }
  }, [getStates]);

  // useEffect(() => {
  //   if (loanMasterData !== undefined) {
  //     let responseAgentArray = [];
  //     loanMasterData.data.map((item) => {
  //       responseAgentArray.push({
  //         value: item.id,
  //         label: item.product_name,
  //         productCode: item.product_code,
  //         productCategory: item.product_category,
  //       });
  //     });
  //     setLoanData(responseAgentArray);
  //   }
  // }, [loanMasterData]);
  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
  };
  const handleChangeAddLead = (event) => {
    setLeadData({
      ...leadDataAdd,
      [event.target.name]: event.target.value,
    });
  };

  //   const generateCattleId = () => {
  //   return Math.floor(1000000000 + Math.random() * 9000000000).toString();
  // };

  // const cattleArray =
  //   leadDataAdd.num_cattle > 0
  //     ? Array.from({ length: leadDataAdd.num_cattle }, () => ({
  //         name: leadDataAdd.first_name,
  //         cattle_id: generateCattleId(),
  //       }))
  //     : [];
  const handleCattleChange = (index, field, value) => {
    const updated = [...cattleData];
    if (field === "cattle_tag_number") {
      value = value.toUpperCase();
    }
    // If cattle_id is missing, generate it once when user starts editing
    if (!updated[index].cattle_id) {
      updated[index].cattle_id = generateCattleId();
    }

    updated[index][field] = value;
    updated[index].name = leadDataAdd?.first_name; // always assign farmer name
    setCattleData(updated);
  };

  const addCattleRow = () => {
    setCattleData([
      ...cattleData,
      {
        cattle_id: generateCattleId(),
        cattle_tag_number: "",
        cattle_tag_date: "",
        name: leadDataAdd?.first_name,
      },
    ]);
  };

  const removeCattleRow = (index) => {
    const updated = [...cattleData];
    updated.splice(index, 1);
    setCattleData(
      updated.length > 0
        ? updated
        : [
            {
              cattle_id: generateCattleId(),
              cattle_tag_number: "",
              cattle_tag_date: "",
              name: leadDataAdd?.first_name,
            },
          ]
    );
  };
  const onSubmitLeadData = (e) => {
    e.preventDefault();
    disableSubmitBtn(true);
    let sendPayload = {
      first_name: leadDataAdd.first_name,
      last_name: leadDataAdd.last_name,
      lead_source: "Dashboard",
      primary_occupation: leadDataAdd.primary_occupation,
      type: "B2C",
      phone_number: leadDataAdd.phone_number,
      DOB: leadDataAdd.DOB.split("-")
        .reverse()
        .join("-"),
      gender: leadDataAdd.gender,
      ...(residentialPinState === "Pincode" && {
        state_name: PincodeDataList.State,
        district_name: PincodeDataList.District,
        block_name: PincodeDataList.Block,
        pincode: PincodeValue,
        address: leadDataAdd.address,
      }),
      ...(residentialPinState === "StateLevel" && {
        state_name: stateName,
        state_code: stateId,
        district_name: districtName,
        district_code: districtId,
        block_code: blockId,
        block_name: blockName,
        address: leadDataAdd.address,
      }),
      lead_details: [
        {
          service_name: "Insurance",
          service_details: {
            product_name: !isaddInsurer ? leadDataAdd.product_name : "Cattle",
            cattle_data: cattleData,
            num_cattle: cattleData.length,
          },
        },
      ],
    };
    createCrmLead(sendPayload)
      .unwrap()
      .then((data) => {
        if (data.success) {
          swal("Lead Created Successfully", {
            buttons: false,
            icon: "success",
            title: "Lead Created Detail",
            timer: 1500,
          });
          setOpenLeadModal(false);
          disableSubmitBtn(false);
          refetch();
        } else {
          swal("Missing Fields", {
            icon: "warning",
            title: "Please fill Full Details",
            timer: 1500,
          });
          disableSubmitBtn(false);
        }
      });
  };

  const handleResidentialChange = (e) => {
    setresidentialPinState(e.target.value);
  };
  const handlePinCodeChange = (e) => {
    const newPinCode = e.target.value;
    if (newPinCode.length <= 6) {
      setPincode(newPinCode);
    }
  };
  useEffect(() => {
    const apiUrl = `https://api.postalpincode.in/pincode/${PincodeValue}`;
    fetch(apiUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data[0].Status === "Success") {
          setPincodeDataList(data[0].PostOffice[0]);
          setPinCodeError(false);
        }
        if (data[0].Status === "Error") {
          setPinCodeError(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [PincodeValue]);

  const handleStateOptions = () => {
    let responseAgentArray = [];
    stateList.map((state) => {
      responseAgentArray.push({
        value: state.state_code,
        label: state.state_name,
        ConditionName: "state",
      });
    });
    return responseAgentArray;
  };
  const handleDistrictOptions = () => {
    let responseAgentArray = [];
    districtList.map((district) => {
      responseAgentArray.push({
        value: district.district_code,
        label: district.district_name,
        ConditionName: "district",
      });
    });
    return responseAgentArray;
  };
  const handleBlockOptions = () => {
    let responseAgentArray = [];
    blockList.map((block) => {
      responseAgentArray.push({
        value: block.block_code,
        label: block.block_name,
        ConditionName: "block",
      });
    });
    return responseAgentArray;
  };
  const onLocationChange = (event) => {
    if (event.ConditionName == "state") {
      setBlockId("");
      setDistrictName("");
      setDistrictId("");
      setBlockName("");
      setBlockList([]);
      setStateId(event.value);
      setStateName(event.label);
    }
    if (event.ConditionName == "district") {
      setDistrictId(event.value);
      setDistrictName(event.label);
      setBlockId("");
      setBlockName("");
    }
    if (event.ConditionName == "block") {
      setBlockId(event.value);
      setBlockName(event.label);
    }
  };
  useEffect(() => {
    if (dataDistrict != undefined) {
      setDistrictList(dataDistrict?.data?.results);
      setloadingDistrictOptions(false);
    }
  }, [dataDistrict]);
  useEffect(() => {
    if (dataBlock != undefined) {
      setBlockList(dataBlock?.data?.results);
    }
  }, [dataBlock]);
  const handleSubmission = () => {
    setDownloadLoader(true);
    const formData = new FormData();
    formData.append("leads_csv", selectedFile);
    formData.append("type", "B2C");
    formData.append("lead_source", "Dashboard");
    formData.append("service_name", "Insurance");
    formData.append("product_name", selectedProduct);
    uploadLeads(formData)
      .unwrap()
      .then((data) => {
        toast.success(
          "Lead uploaded successfully! Please wait 10–15 minutes for further processing."
        );
        setOpenLeadModal(false);
        setDownloadLoader(false);
        setSelectedFile();
        // refetch();
      })
      .catch((error) => {
        toast.error("Error while Uploading Leads");
        setDownloadLoader(false);
        setOpenLeadModal(false);
        return;
      });
  };
  //   const sampleExcel = () => {
  //   const headers = [
  //     "first_name",
  //     "last_name",
  //     "phone_number",
  //     "DOB",
  //     "gender",
  //     "primary_occupation",
  //     "state_name",
  //     "district_name",
  //     "block_name",
  //     "pincode",
  //     "address",
  //     "cattle_name"
  //   ];

  //   const sampleRow = [
  //     "Kunal",
  //     "Singh",
  //     "6876543210",
  //     "1990-05-15",
  //     "Male",
  //     "Farmer",
  //     "Uttar Pradesh",
  //     "Lucknow",
  //     "Bakshi Ka Talab",
  //     "226201",
  //     "123, Near Hanuman Mandir, Lucknow",
  //     "Desi Cow"
  //   ];

  //   const csvContent = [headers.join(","), sampleRow.join(",")].join("\n");

  //   const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  //   const url = URL.createObjectURL(blob);
  //   const link = document.createElement("a");
  //   link.href = url;
  //   link.setAttribute("download", "SampleLead.csv");
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };
  const sampleExcel = () => {
    const url =
      "https://agrani-public-media.s3.ap-south-1.amazonaws.com/cattle_insurance_sample_csv.csv";
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "cattle_insurance_sample_csv.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <div className="d-flex justify-content-center gap-2 mb-3">
        <Button
          size="sm"
          variant={showSingleLeads ? "warning" : "outline-warning"}
          onClick={() => setShowSingleLeads(true)}
        >
          Create Lead
        </Button>
        <Button
          size="sm"
          variant={!showSingleLeads ? "warning" : "outline-warning"}
          onClick={() => setShowSingleLeads(false)}
        >
          Bulk Upload
        </Button>
      </div>

      {showSingleLeads ? (
        <div className="formdetails mt-4">
          <form onSubmit={onSubmitLeadData}>
            <div className="row">
              <div className="col-lg-3 form-group mb-3 text_box">
                <Label className="f_p text_c f_400">
                  First Name <small className="text-danger">*</small>
                </Label>
                <input
                  name="first_name"
                  type="text"
                  className="form-control"
                  placeholder="Enter First Name"
                  required
                  value={leadDataAdd.first_name}
                  onChange={handleChangeAddLead}
                />
              </div>

              <div className="col-lg-3 form-group mb-3 text_box">
                <Label className="f_p text_c f_400">Last Name</Label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter Last Name"
                  name="last_name"
                  value={leadDataAdd.last_name}
                  onChange={handleChangeAddLead}
                />
              </div>
              <div className="col-lg-3 form-group mb-3 text_box">
                <Label className="f_p text_c f_400">
                  Phone Number <small className="text-danger">*</small>
                </Label>
                <input
                  name="phone_number"
                  type="text"
                  pattern="^[0-9\b]+$"
                  className="form-control"
                  placeholder="Enter 10 digit Number"
                  minLength="10"
                  maxLength="10"
                  required
                  value={leadDataAdd.phone_number}
                  onChange={handleChangeAddLead}
                />
              </div>

              <div className="col-lg-3 form-group mb-3 text_box">
                <Label className="f_p text_c f_400">
                  DOB<small className="text-danger">*</small>
                </Label>
                <input
                  name="DOB"
                  type="date"
                  className="form-control"
                  placeholder="Enter DOB"
                  required
                  value={leadDataAdd.DOB}
                  onChange={handleChangeAddLead}
                />
              </div>
              <div className="col-lg-3 form-group mb-2 text_box">
                <Label className="f_p text_c f_400">
                  Gender <small className="text-danger">*</small>
                </Label>

                <select
                  name="gender"
                  style={{ padding: "15px" }}
                  className="form-control"
                  required
                  value={leadDataAdd.gender}
                  onChange={handleChangeAddLead}
                >
                  <option value="" selected disabled>
                    Select
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              {!isaddInsurer && (
                <div className="col-lg-3 form-group mb-3 text_box">
                  <Label className="f_p text_c f_400">
                    Product Name <small className="text-danger">*</small>
                  </Label>

                  <select
                    className="form-control fs-6"
                    required
                    placeholder="Enter Product Name"
                    name="product_name"
                    onChange={handleChangeAddLead}
                    style={{ padding: "15px" }}
                    value={leadDataAdd.product_name}
                  >
                    <option value="" selected disabled>
                      Select
                    </option>
                    <option value="Health Insurance">Health Insurance</option>
                    <option value="Cattle">Cattle</option>
                    <option value="Motor">Motor</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              )}

              <div className="col-lg-3 form-group mb-3 text_box">
                <Label className="f_p text_c f_400">
                  Primary Occupation <small className="text-danger">*</small>
                </Label>

                <select
                  className="form-control"
                  name="primary_occupation"
                  style={{ padding: "15px" }}
                  required
                  value={leadDataAdd.primary_occupation}
                  onChange={handleChangeAddLead}
                >
                  <option value="">Select</option>

                  <option value="Agriculture">Agriculture</option>
                  <option value="Trader">Trader</option>
                  <option value="Public Sector">Public Sector</option>
                  <option value="Private Sector">Private Sector</option>
                  <option value="Dairy Farmer">Dairy Farmer</option>

                  <option value="Others">Others</option>
                </select>
              </div>
              {/* <div className="col-lg-3 form-group mb-3 text_box">
            <Label className="f_p text_c f_400">
              No Of Cattle<small className="text-danger">*</small>
            </Label>
            <input
              name="num_cattle"
              type="number"
              className="form-control"
              placeholder="Cattle Number"
              required
              value={leadDataAdd.num_cattle}
              onChange={handleChangeAddLead}
            />
          </div> */}

              {/* <Row>
            <Col lg="5" className="">
              <label>
                <b> Details Based on</b>
              </label>
              <FormGroup className="mt-2">
                <div className="d-flex flex-row">
                  <Label className="d-flex align-items-center">
                    <Input
                      type="radio"
                      name="home"
                      value="Pincode"
                      checked={residentialPinState === "Pincode"}
                      onChange={handleResidentialChange}
                    />
                    <span className="ms-2 mt-1">Pincode</span>
                  </Label>
                  <Label className="d-flex align-items-center mt-1 mx-5">
                    <Input
                      type="radio"
                      name="home"
                      value="StateLevel"
                      checked={residentialPinState === "StateLevel"}
                      onChange={handleResidentialChange}
                    />
                    <span className="ms-2 mt-1">
                      Based on State, District, Block
                    </span>
                  </Label>
                </div>
              </FormGroup>
            </Col>
          </Row> */}
              {/* {residentialPinState === "Pincode" ? (
            <Row className="text-gray mt-2">
              <Col lg="3" className="mb-4">
                <CustomTextField
                  type="number"
                  name="pincode"
                  value={PincodeValue}
                  onChange={handlePinCodeChange}
                  maxLength="6"
                  placeholder="Pincode"
                  required
                />
                {PincodeValue.length > 6 || pincodeError ? (
                  <div className="text-danger mt-1">Enter a valid pincode</div>
                ) : null}
              </Col>

              <Col lg="3" className="mb-4">
                <CustomTextField
                  type="text"
                  name="State"
                  value={PincodeDataList.State}
                  disabled
                  placeholder="State"
                />
              </Col>
              <Col lg="3" className="mb-4">
                <CustomTextField
                  type="text"
                  name="District"
                  value={PincodeDataList.District}
                  disabled
                  placeholder="District"
                />
              </Col>
              <Col lg="3" className="mb-4">
                <CustomTextField
                  type="text"
                  name="Block"
                  value={PincodeDataList.Block}
                  disabled
                  placeholder="Block"
                />
              </Col>

              <Col lg="8" className="mb-4">
                <CustomTextField
                  type="text"
                  name="address"
                  value={leadDataAdd.address}
                  onChange={handleChangeAddLead}
                  placeholder="Full Address"
                  required
                />
              </Col>
            </Row>
          ) : residentialPinState === "StateLevel" ? ( */}
              <h5>Location Details</h5>
              <Row className="text-gray mt-2">
                <Col lg="3" className="mb-4">
                  <label className="text-black"> State</label>
                  <Select
                    menuPlacement="auto"
                    options={handleStateOptions()}
                    placeholder={stateId === "" ? "Select State" : stateName}
                    value={stateId === "" ? "Select State" : stateName}
                    onChange={onLocationChange}
                    styles={customStyles}
                    isLoading={loadingStateOptions}
                    className="mt-2"
                  />
                </Col>
                <Col lg="3" className="mb-4">
                  <label className="text-black"> District</label>
                  <Select
                    menuPlacement="auto"
                    isLoading={loadingDistrictOptions}
                    options={handleDistrictOptions()}
                    placeholder={
                      districtName == "" ? "Select District" : districtName
                    }
                    value={
                      districtName === "" ? "Select District" : districtName
                    }
                    onChange={onLocationChange}
                    styles={customStyles}
                    className="mt-2"
                  />
                </Col>
                <Col lg="3" className="mb-4">
                  <label className="text-black"> Block</label>
                  <Select
                    menuPlacement="auto"
                    options={handleBlockOptions()}
                    placeholder={blockName == "" ? "Select Block" : blockName}
                    value={blockName === "" ? "Select Block" : blockName}
                    onChange={onLocationChange}
                    styles={customStyles}
                    className="mt-2"
                  />
                </Col>

                <Col lg="6" className="mb-4">
                  <CustomTextField
                    type="text"
                    name="address"
                    value={leadDataAdd.address}
                    onChange={handleChangeAddLead}
                    required
                  />
                </Col>
              </Row>
              {/* ) : (
            ""
          )} */}
              <h5 className="mt-3 d-flex justify-content-between align-items-center">
                <span>Cattle Details</span>
                <Button
                  type="button"
                  color="primary"
                  className="d-flex align-items-center gap-1 shadow-sm"
                  style={{ borderRadius: "10px", fontWeight: "500" }}
                  onClick={addCattleRow}
                >
                  <i className="mdi mdi-account-plus custom-btn-fs fs-6"></i>{" "}
                  Add Cattle
                </Button>
              </h5>

              {cattleData.map((cattle, index) => (
                <div
                  key={index}
                  className="p-3 border rounded shadow-sm mt-3"
                  style={{ background: "#fafafa" }}
                >
                  <div className="row g-3 align-items-end">
                    <div className="col-md-5">
                      <label className="form-label fw-semibold">
                        Cattle Tag No.
                      </label>
                      <input
                        type="text"
                        className="form-control text-uppercase"
                        placeholder="Enter Cattle Tag No."
                        value={cattle.cattle_tag_number}
                        onChange={(e) =>
                          handleCattleChange(
                            index,
                            "cattle_tag_number",
                            e.target.value
                          )
                        }
                        required
                      />
                    </div>
                    <div className="col-md-5">
                      <label className="form-label fw-semibold">
                        Cattle Tagging Date
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        value={cattle.cattle_tag_date}
                        onChange={(e) =>
                          handleCattleChange(
                            index,
                            "cattle_tag_date",
                            e.target.value
                          )
                        }
                        required
                      />
                    </div>
                    <div className="col-md-2 text-end">
                      {/* <Button
                        type="button"
                        varient="outline-warning"
                        className="d-flex align-items-center gap-1"
                        style={{ borderRadius: "10px" }}
                        onClick={() => removeCattleRow(index)}
                      >
                        <i className="mdi mdi-trash-can custom-btn-fs fs-6"></i>{" "}
                        Remove
                      </Button> */}
                      <Button
                        size="sm"
                        variant="outline-warning"
                        className="d-flex align-items-center gap-1"
                        onClick={() => removeCattleRow(index)}
                      >
                        <i className="mdi mdi-trash-can custom-btn-fs fs-6"></i>{" "}
                        Remove
                      </Button>
                    </div>
                  </div>
                </div>
              ))}

              <div className="mt-3">
                <Button
                  className="submit-btn"
                  type="submit"
                  disabled={disableButton2 ? true : false}
                  style={{ float: "right" }}
                >
                  Submit &nbsp;
                  {disableButton2 ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    ""
                  )}
                </Button>
              </div>
            </div>
          </form>
        </div>
      ) : (
        <>
          <div className="text-center mb-3 px-3 mt-3">
            <p className="mb-1 fw-semibold text-dark">Bulk Upload Leads</p>
            <small className="text-muted">
              Start by downloading the sample CSV file, fill in the details, and
              then upload your completed file below.
            </small>
          </div>
          <div className="text-center">
            <Button
              onClick={sampleExcel}
              variant="outline-primary"
              size="sm"
              className="fw-semibold shadow-sm px-3"
            >
              <i className="mdi mdi-download custom-btn-fs fs-6"></i> Download
              Sample CSV
            </Button>
          </div>
          <div className="d-flex flex-column align-items-center mt-4 mx-2">
            <label
              htmlFor="file-upload"
              className="w-100 text-center p-5 border border-2 border-dashed rounded bg-white shadow-sm"
              style={{ maxWidth: "500px", cursor: "pointer" }}
            >
              <CloudUploadIcon style={{ fontSize: "40px", color: "#0d6efd" }} />
              <p className="mb-1 fw-medium text-secondary">
                <span className="text-primary fw-semibold">
                  Click to upload
                </span>{" "}
                or drag & drop
              </p>
              <small className="text-muted">Only .csv files are allowed</small>
              <input
                id="file-upload"
                type="file"
                name="file"
                accept=".csv"
                className="d-none"
                onChange={changeHandler}
                // onDragOver={(e) => e.preventDefault()}
                // onDrop={(e) => {
                //   e.preventDefault();
                //   const files = e.dataTransfer.files;
                //   if (files.length > 0) {
                //     changeHandler({ target: { files } });
                //   }
                // }}
              />
            </label>
            {selectedFile && (
              <div className="mt-2 text-muted small">
                <strong>Selected file:</strong> {selectedFile.name}
              </div>
            )}
            <Button
              id="AddLeads"
              className="buttonGreenDefaultColor mt-3 px-4 shadow-sm mb-2"
              onClick={(e) => handleSubmission()}
              size="sm"
              disabled={downloadLoader}
            >
              {downloadLoader ? (
                <>
                  <Spinner animation="border" size="sm" /> &nbsp; Uploading...
                </>
              ) : (
                "Submit"
              )}
            </Button>
          </div>
        </>
      )}
    </>
  );
};
export default CrmAddLead;
